module.exports = __webpack_public_path__ + "img/team_4_index.1175a12f.png";